var map = {
	"./EHS-losses.svg": "./src/assets/img/maturity-dashboard-adm/EHS-losses.svg",
	"./FTE-breakdown.svg": "./src/assets/img/maturity-dashboard-adm/FTE-breakdown.svg",
	"./add-plant-popup.svg": "./src/assets/img/maturity-dashboard-adm/add-plant-popup.svg",
	"./assign.svg": "./src/assets/img/maturity-dashboard-adm/assign.svg",
	"./available-training-course.svg": "./src/assets/img/maturity-dashboard-adm/available-training-course.svg",
	"./blue-close-icon.svg": "./src/assets/img/maturity-dashboard-adm/blue-close-icon.svg",
	"./cancel-dark.svg": "./src/assets/img/maturity-dashboard-adm/cancel-dark.svg",
	"./cir-select-chk.svg": "./src/assets/img/maturity-dashboard-adm/cir-select-chk.svg",
	"./clear-overview-search.svg": "./src/assets/img/maturity-dashboard-adm/clear-overview-search.svg",
	"./computer-screen-with-solutions.svg": "./src/assets/img/maturity-dashboard-adm/computer-screen-with-solutions.svg",
	"./cross-btn.svg": "./src/assets/img/maturity-dashboard-adm/cross-btn.svg",
	"./ddl-trangle.svg": "./src/assets/img/maturity-dashboard-adm/ddl-trangle.svg",
	"./demo-user.svg": "./src/assets/img/maturity-dashboard-adm/demo-user.svg",
	"./digital-label-icon.svg": "./src/assets/img/maturity-dashboard-adm/digital-label-icon.svg",
	"./disabled-btn.svg": "./src/assets/img/maturity-dashboard-adm/disabled-btn.svg",
	"./done-check.png": "./src/assets/img/maturity-dashboard-adm/done-check.png",
	"./email-list-cancel.svg": "./src/assets/img/maturity-dashboard-adm/email-list-cancel.svg",
	"./exclude.svg": "./src/assets/img/maturity-dashboard-adm/exclude.svg",
	"./eye.svg": "./src/assets/img/maturity-dashboard-adm/eye.svg",
	"./finance-data.svg": "./src/assets/img/maturity-dashboard-adm/finance-data.svg",
	"./general-information.svg": "./src/assets/img/maturity-dashboard-adm/general-information.svg",
	"./industry-ico.svg": "./src/assets/img/maturity-dashboard-adm/industry-ico.svg",
	"./industry-vision-dm.svg": "./src/assets/img/maturity-dashboard-adm/industry-vision-dm.svg",
	"./it-losses.svg": "./src/assets/img/maturity-dashboard-adm/it-losses.svg",
	"./loss-analysis-label-icon.svg": "./src/assets/img/maturity-dashboard-adm/loss-analysis-label-icon.svg",
	"./loss-label-icon.svg": "./src/assets/img/maturity-dashboard-adm/loss-label-icon.svg",
	"./maintenance-losses.svg": "./src/assets/img/maturity-dashboard-adm/maintenance-losses.svg",
	"./manufacturing-cost.svg": "./src/assets/img/maturity-dashboard-adm/manufacturing-cost.svg",
	"./material-waste.svg": "./src/assets/img/maturity-dashboard-adm/material-waste.svg",
	"./md8-cybersecurity-data-architecture.svg": "./src/assets/img/maturity-dashboard-adm/md8-cybersecurity-data-architecture.svg",
	"./md8-ehs.svg": "./src/assets/img/maturity-dashboard-adm/md8-ehs.svg",
	"./md8-industry -4.0-vision.svg": "./src/assets/img/maturity-dashboard-adm/md8-industry -4.0-vision.svg",
	"./md8-information-systems.svg": "./src/assets/img/maturity-dashboard-adm/md8-information-systems.svg",
	"./md8-maintenance.svg": "./src/assets/img/maturity-dashboard-adm/md8-maintenance.svg",
	"./md8-op-ex.svg": "./src/assets/img/maturity-dashboard-adm/md8-op-ex.svg",
	"./md8-production-execution.svg": "./src/assets/img/maturity-dashboard-adm/md8-production-execution.svg",
	"./md8-quality.svg": "./src/assets/img/maturity-dashboard-adm/md8-quality.svg",
	"./md8-warehouse-material-handling.svg": "./src/assets/img/maturity-dashboard-adm/md8-warehouse-material-handling.svg",
	"./minor-stops.svg": "./src/assets/img/maturity-dashboard-adm/minor-stops.svg",
	"./minus.svg": "./src/assets/img/maturity-dashboard-adm/minus.svg",
	"./more-icon.svg": "./src/assets/img/maturity-dashboard-adm/more-icon.svg",
	"./ms-assign-search.svg": "./src/assets/img/maturity-dashboard-adm/ms-assign-search.svg",
	"./ms-unsaved.svg": "./src/assets/img/maturity-dashboard-adm/ms-unsaved.svg",
	"./my-training.svg": "./src/assets/img/maturity-dashboard-adm/my-training.svg",
	"./operator-losses.svg": "./src/assets/img/maturity-dashboard-adm/operator-losses.svg",
	"./overview-assign-img.svg": "./src/assets/img/maturity-dashboard-adm/overview-assign-img.svg",
	"./planned-downtime.svg": "./src/assets/img/maturity-dashboard-adm/planned-downtime.svg",
	"./plant-circle.svg": "./src/assets/img/maturity-dashboard-adm/plant-circle.svg",
	"./plant.svg": "./src/assets/img/maturity-dashboard-adm/plant.svg",
	"./plants-label-icon.svg": "./src/assets/img/maturity-dashboard-adm/plants-label-icon.svg",
	"./product-tab-img.svg": "./src/assets/img/maturity-dashboard-adm/product-tab-img.svg",
	"./quality-losses.svg": "./src/assets/img/maturity-dashboard-adm/quality-losses.svg",
	"./report-problem.svg": "./src/assets/img/maturity-dashboard-adm/report-problem.svg",
	"./speed-losses.svg": "./src/assets/img/maturity-dashboard-adm/speed-losses.svg",
	"./submit-animation.png": "./src/assets/img/maturity-dashboard-adm/submit-animation.png",
	"./td-search-icon.svg": "./src/assets/img/maturity-dashboard-adm/td-search-icon.svg",
	"./toggle-icon.svg": "./src/assets/img/maturity-dashboard-adm/toggle-icon.svg",
	"./training-course.svg": "./src/assets/img/maturity-dashboard-adm/training-course.svg",
	"./unplanned-downtime.svg": "./src/assets/img/maturity-dashboard-adm/unplanned-downtime.svg",
	"./user-circle.svg": "./src/assets/img/maturity-dashboard-adm/user-circle.svg",
	"./user.svg": "./src/assets/img/maturity-dashboard-adm/user.svg",
	"./verify-email-check.svg": "./src/assets/img/maturity-dashboard-adm/verify-email-check.svg",
	"./warehouse-losses.svg": "./src/assets/img/maturity-dashboard-adm/warehouse-losses.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/maturity-dashboard-adm sync recursive ^\\.\\/.*$";